module.exports = __webpack_public_path__ + "img/6.9cff9385.png";